jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

    // disable buy now button
    $(".shopify-payment-button").addClass("shopify-payment-button-disable");
    ///// check pincode for availability
    $("#pincodeCheckerBtn").on("click",function(){
        var availablePincodeArray = ['721101','721102','721301','721302','721303','721304','721305','721306','721506','721507','721513','721514','721102','721129','721147','721253'];
        let pincode = $("#pincodeChecker").val();
        //alert("button");
        if(pincode.trim() == ""){
          alert("Please enter pincode first.");
        }else{
          //alert(pincode);
          if(availablePincodeArray.indexOf(pincode) != -1){
            $("#availablePinCode").show();
            $("#unavailablePinCode").hide();
            $(".shopify-payment-button").removeClass("shopify-payment-button-disable");
            $(".shopify-payment-button").addClass("shopify-payment-button-enable");
          }else{
            $("#availablePinCode").hide();
            $("#unavailablePinCode").show();
            $(".shopify-payment-button").removeClass("shopify-payment-button-enable");
            $(".shopify-payment-button").addClass("shopify-payment-button-disable");
          }
        }
    }); 

    /////////// to disable enter key ///////////////
    $(document).on('keypress',function(e) {
        //alert('keyup');
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) { 
          //alert('you pressed enter');
          e.preventDefault();
          return false;
        }
    });
});


